import { render, staticRenderFns } from "./Action.vue?vue&type=template&id=0fab1318&scoped=true"
import script from "./Action.vue?vue&type=script&lang=ts"
export * from "./Action.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fab1318",
  null
  
)

export default component.exports